module.exports = __webpack_public_path__ + "static/it_services__home-e9f3c1c3ddf0a0bafa2cf8239ec7bc47.jpg";